import { nanoid } from 'nanoid';

function generateNanoId(size?: number): string {
  return nanoid(size);
}

export default generateNanoId;
